import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overviewTab", "settingsTab"]
  
  connect() {
    console.log("connected!!!")
    this.updateActiveTab()
  }
  
  updateActiveTab() {
    const path = window.location.pathname
    
    // Reset all tabs
    this.overviewTabTarget?.classList.remove('active')
    this.settingsTabTarget?.classList.remove('active')
    
    // Set active based on current path
    if (path.includes('/settings') || path.includes('/edit')) {
      this.settingsTabTarget?.classList.add('active')
    } else {
      this.overviewTabTarget?.classList.add('active')
    }
  }
  
  // Method to call after any Turbo frame loads
  afterFrameLoad() {
    this.updateActiveTab()
  }
}